import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ContrastTable } from './components/ContrastTable';
import { ProductPresentation } from './components/ProductPresentation';
import { ChaptersSection } from './components/ChaptersSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Facebook domain verification meta tag
    const meta = document.createElement('meta');
    meta.name = 'facebook-domain-verification';
    meta.content = 'h8n7th37rf8c6ufbk58syvhnhdtwu3';
    document.head.appendChild(meta);
    // Meta Pixel
    const pixelScript = document.createElement('script');
    pixelScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2410443156143104');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(pixelScript);
    // Meta Pixel noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=2410443156143104&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(meta);
      document.head.removeChild(pixelScript);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-cream text-neutral-800 font-sans selection:bg-brand-200 selection:text-brand-900" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainSection data-id="element-3" />
        <ContrastTable data-id="element-4" />
        <ProductPresentation data-id="element-5" />
        <ChaptersSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FAQSection data-id="element-11" />
      </main>
      <SocialProofPopup data-id="element-12" />
    </div>;
}